import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { formatFileSize } from '../../utils/helper';
import { assignment } from '../../pages/Assignments/Assignments';
import Loader from '../Loader/Loader';
import '../FileViewer/FileViewer.scss';
import { Tooltip } from '@mui/material';

interface Material {
  filename: string;
  filepath: string;
  filesize: number;
  isclassroom: boolean;
  coverimagepath?: string;
  authorname?: string;
}

interface PropsType {
  fileUrl: string;
  fileData: Material | assignment | undefined;
  onClose: () => void;
  type?: string;
  fileType: "docs" | "ppt" | "excel" | "pdf"
}

const FileViewerSystemMessages: FC<PropsType> = ({ fileUrl, fileData, onClose ,type, fileType}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  
  // Effect to handle fetching of file details
  useEffect(() => {
    setIframeSrc(fileType === "docs" || fileType === "excel" ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}` : `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true&hl=en`);   
  }, [fileData, fileUrl]);

  // Handle iframe load event to hide the loader
  const handleIframeLoad = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  };

  const textRef = useRef<HTMLDivElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  // Function to check if text is truncated
  const checkEllipsis = useCallback(() => {
    if (textRef.current) {
      setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkEllipsis(); // Check on mount
    window.addEventListener("resize", checkEllipsis); // Recheck on resize

    return () => window.removeEventListener("resize", checkEllipsis); // Cleanup on unmount
  }, [checkEllipsis, fileData?.filename]);
  
  return (
    <div className="FileViewContainer">
      {(type !== "chat" && type !== "system_messages") ? 
      <div className="FileHeader">
        <Tooltip title={isEllipsisActive ? fileData?.filename : ""}>
                <div ref={textRef} className="fileName">
                  {fileData?.filename|| 'Untitled File'}
                </div>
                </Tooltip>
        <div className="fileSize">
          Size: {fileData?.filesize ? formatFileSize(fileData.filesize) : '0 MB'}
        </div>
      </div>
      :<></>
      }
      <div className="frameContainer">
        {isLoading && <Loader bottom="110px" />}

        {iframeSrc && (
          <iframe
            src={iframeSrc}
            className="msViewer"
            onLoad={handleIframeLoad}
            style={{ display: isLoading ? 'none' : 'block' }}
            title=" "
            onContextMenu={(e) => e.preventDefault()}
          ></iframe>
        )}
        {((fileType === "docs" ) && !isLoading && iframeSrc) && <div className="hideBottomControls"></div>}
        {((fileType === "excel") && !isLoading && iframeSrc) && <div className="hideBottomControlsForExcel"></div>}
        {(fileType === "ppt" || fileType === "pdf") && <div className='hidePptDownloadOption'/>}
        {fileType === "docs" && !isLoading && iframeSrc && <div className="hideBorderTop"></div>}
        {fileType === "docs" && !isLoading && iframeSrc && <div className="hideBorderLeft"></div>}
      </div>
    </div>
  );
};

export default FileViewerSystemMessages;